module.exports = __webpack_public_path__ + "static/media/bg.5b81fc60.svg";